export default __webpack_public_path__ + "../staticImages/SST-260.png";